import React from "react";
import {
  Grid,
  Button,
  Dialog,
  DialogContent,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";

import Services from "../../Services";
import DynamicInput from "../InputComponents/DynamicInput";

const { hr } = Services;

const StatusModal = ({ modalData }) => {
  let {
    employeeDetails,
    open,
    close,
    changeDate,
    mainFlag,
    setMainFlag,
    updateStatusState,
    updateStatus,
    dateStatus,
    listStatus,
  } = modalData;
  const theme = useTheme();

  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  let fields = [
    {
      type: 2,
      name: "Effective Date",
      initial: dateStatus,
      isRequired: true,
      defaultDate: null,
      onChange: (value) => changeDate(value),
    },
    {
      type: 3,
      key: "status",
      options: listStatus.filter((data) => data.key > 8 && data.key != 10 && data.key != 11),
      isRequired: true,
      name: "Status",
      onChange: (newValue) => updateStatus(newValue),
    },
  ];

  function onUpdateStatus(e) {
    e.preventDefault();
    let data = {
      id: employeeDetails?.id,
      status: parseInt(updateStatusState.key),
      effective_date: dateStatus,
    };

    try {
      hr.onUpdateStatusModal(data)
        .then((certificateData) => {
          close(false);
          changeDate(null);
          setMainFlag(!mainFlag);
        })
        .catch((err) => {
           
        });
    } catch (exc) {
       
    }
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={() => close(false)}
      className="BroadcastMessageModal LiqTables"
      aria-labelledby="responsive-dialog-title"
    >
      <Button
        autoFocus
        onClick={() => close(false)}
        className="ModalClose"
      ></Button>

      <form onSubmit={onUpdateStatus}>
        <h2> Change Employee Status</h2>
        <DialogContent style={{ height: "630px" }}>
          <DynamicInput fields={fields} />
          <Grid xs={12} container justify="center" className="mt30">
            <Button type="submit" className="LinkButton">
              Save
            </Button>
          </Grid>
        </DialogContent>
      </form>
    </Dialog>
  );
};

export default StatusModal;
